<template>
  <img
    @click="returnColidee"
    src="~@/assets/img/icons/arrow-left-icon.png"
    class="icon"
    alt="logo-return-colidee"
  
  />
</template>

<script>
export default {
  name: 'ButtonReturnColidee',
  props: {
    adminComponent: {
      type: Boolean
    }
  },
  methods: {
    returnColidee () {
      if (this.adminComponent) {
        this.$store.commit('ADMIN_ACTIVE_COMPONENTS', {
          cardList: true,
          parameters: false,
          searchBar: false
        }
        )
      } else {
        this.$router.push({ name: 'Admin' })
      }
    }
  }
}
</script>
<style scoped>
.icon {
  width: 30px;
  height: 30px;
  cursor: pointer;
  margin-left:10px;
  background:white;
  border-radius:10px;
  padding:2px
}
</style>



// WEBPACK FOOTER //
// src/components/base/ButtonReturnColidee.vue